import {useIntl} from 'react-intl';
import {useEffect, useState, useRef} from 'react';
import Modal from 'Components/Modal';
import QuickViewCard from 'Components/ProgramFinder/QuickViewCard/ies';
import {Tooltip} from 'react-tippy';
import {ReactComponent as TooltipIcon} from 'assets/icons/tooltip.svg';
import {ReactComponent as Heart} from 'assets/icons/heart.svg';
import {postFavoriteProgram} from 'Callbacks/flagFavorites';

const CardItem = ({data, isFavorite, setFavorites, userLoggedIn}) => {
  const intl = useIntl();
  const {
    nid,
    field_prgm_type,
    program_card_image,
    displayed_destination,
    field_short_title,
    title,
    field_prgm_term_type,
    field_prgm_lang_pre_lvl,
    field_prgm_options,
    field_prgm_cost_units,
    field_prgm_cost_est,
  } = data || {};
  const url = `/node/${nid}`
  const card = useRef(null);
  const cardMobile = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line no-undef
    Drupal.attachBehaviors(card.current);
    // eslint-disable-next-line no-undef
    Drupal.attachBehaviors(cardMobile.current);
  }, []);

  if (!data) {
    return '';
  }

  const programTermType = () => {
    if (!field_prgm_term_type) {
      return '';
    }
    let value = '';

    if (typeof field_prgm_term_type === 'string') {
      value = field_prgm_term_type;
    } else if (typeof field_prgm_term_type === 'object') {
      field_prgm_term_type.forEach((termType, index) => {
        value += index < (field_prgm_term_type.length - 1) ? `${termType} / ` : termType;
      });
    }

    return (
      <div className="program--length mb-10">
        <label className="font-bold inline">{intl.formatMessage({id: 'ProgramCard.TermType'})}</label>
        {value}
      </div>
    );
  };

  const programType = () => {
    if (!field_prgm_type) {
      return '';
    }

    const classes = (type) => {
      return `link--tag inline-flex ${type === 'Standard' ? 'link--tag-pink' : type === 'Internship' ? 'link--tag-green' : 'link--tag-purple'}`;
    };

    const typeRewrite = (type) => {
      return type === 'Standard' ? 'Study Abroad' : type === 'Internship' ? 'Full-time Internship' : type;
    };

    if (typeof field_prgm_type === 'string') {
      return (
        <span className={classes(field_prgm_type)}>{typeRewrite(field_prgm_type)}</span>
      );
    } else if (typeof field_prgm_type === 'object') {
      return field_prgm_type.map((type) => {
        return (
          <span className={classes(type)}>{typeRewrite(type)}</span>
        );
      })
    }
  };

  const favorites = () => {
    const loggedIn = (
      <>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#" className="flag-button" rel="nofollow" onClick={(e) => {
          e.preventDefault();
          postFavoriteProgram(intl, nid, !isFavorite).then((res) => {
            if (res !== null) {
              setFavorites(res);
            }
          });
        }}>
          <span className="visually-hidden">{intl.formatMessage({id: 'ProgramCard.Favorites.Button'})}</span>
          <Heart/>
        </a>
      </>
    );

    const notLoggedIn = (
      <>
        <button className="flag-button flag-button--disabled">
          <span className="visually-hidden">{intl.formatMessage({id: 'ProgramCard.Favorites.NotLogged.Button'})}</span>
          <Heart/>
        </button>
      </>
    );

    return (
      <div className="card__favorites js-dL-programcardSave" style={{visibility: isFavorite === null ? 'hidden' : ''}}>
        <div className={`flag flag-favorites ${isFavorite ? 'action-unflag' : 'action-flag'}`}>
          {
            userLoggedIn ?
              loggedIn : notLoggedIn
          }
        </div>
      </div>
    );
  };

  const desktop = (
    <article ref={card}
             className="node node--type-program node--view-mode-card program program-card js-modal-parent-target hidden lg:block overflow-hidden shadow-default">
      <div className="program-card__image-container program-half__image-container relative">
        <div className="program--type absolute top-20 left-20">
          {programType()}
        </div>

        {favorites()}

        <div className="overflow-hidden" dangerouslySetInnerHTML={{__html: program_card_image}}/>
      </div>

      <div className="program-card__details-container py-20 px-22 flex-col flex"
           data-program-type={field_prgm_type}
           data-program-locality={displayed_destination}>
        {displayed_destination ?
          <div className="program--location mb-4">
            {typeof displayed_destination === 'string' ? displayed_destination : displayed_destination.join(' | ')}
          </div> : ''
        }

        <h3 className="program--title mb-16">
          <a href={url} rel="bookmark" className="text-grey-dark no-underline">
            <span className="link--custom-underline">
              {field_short_title ? field_short_title : title}
            </span>
          </a>
        </h3>

        <div className="program-card__hover js-dL-programcardHover">
          {programTermType()}

          <div className="program--lang-prereq mb-10">
            <label className="font-bold inline">
              {intl.formatMessage({id: 'ProgramCard.PrerequisitesLanguage'})}
            </label>
            {typeof field_prgm_lang_pre_lvl === 'object' ? field_prgm_lang_pre_lvl.join(', ') : field_prgm_lang_pre_lvl}
          </div>

          {field_prgm_options ?
            <div className="program--options mb-10">
              <label className="font-bold inline">{intl.formatMessage({id: 'ProgramCard.ProgramOptions'})}</label>
              {typeof field_prgm_options === 'object' ? field_prgm_options.join(', ') : field_prgm_options}
            </div> : ''
          }
        </div>

        <div className="program-card__details-footer mt-auto">
          {field_prgm_cost_est ?
            <div className="program--costs flex justify-between">
              <label>{intl.formatMessage({id: 'ProgramCard.EstimatedCost'})}
                <div className="program-tooltip">
                  <Tooltip title={intl.formatMessage({id: 'ProgramCard.ProgramCostTooltip'})}
                           arrow={true}
                           tabIndex={0}
                           inertia={true}
                           interactive={true}>
                    <TooltipIcon/>
                  </Tooltip>
                </div>
              </label>

              <div className="program--price font-bold text-grey-dark flex">
                {field_prgm_cost_est === -1 ?
                  intl.formatMessage({id: 'ProgramCard.Price.Pending'})
                  : `${field_prgm_cost_units}${intl.formatNumber(field_prgm_cost_est)}`
                }
              </div>
            </div> : ''
          }
          <button
            className="button button--small justify-center w-full program-card__hover mt-24 js-open-modal js-dL-programcardQuickView"
            onClick={() => setIsOpen(true)}>
            {intl.formatMessage({id: 'ProgramCard.QuickView.Button'})}
          </button>

          {
            isOpen &&
            <Modal
              setIsOpen={setIsOpen}
              modalContent={
                <QuickViewCard data={data}
                               url={url}
                               programType={programType()}
                               userLoggedIn={userLoggedIn}
                               isFavorite={isFavorite}
                               setFavorites={setFavorites}/>
              }
              contentClasses="modal-content--center"
            />
          }
        </div>
      </div>
    </article>
  );

  const mobile = (
    <article ref={cardMobile}
             className="program program-card-mobile overflow-hidden lg:hidden swiper-slide flex flex-col">
      <div className="program-half__image-container relative">
        <div className="program--type absolute top-20 left-20">
          {programType()}
        </div>

        {favorites()}

        <div className="overflow-hidden" dangerouslySetInnerHTML={{__html: program_card_image}}/>
      </div>

      <div
        className="program-card-mobile__details-container py-20 px-22 flex flex-col bg-yellow-lighter h-auto flex-grow"
        data-program-type={field_prgm_type}
        data-program-locality={displayed_destination}>
        {displayed_destination ?
          <div className="program--location mb-4">
            {typeof displayed_destination === 'string' ? displayed_destination : displayed_destination.join(' | ')}
          </div> : ''
        }

        <h3 className="program--title mb-16">
          <a href={url} rel="bookmark" className="text-grey-dark no-underline link--custom-underline">
            {field_short_title ? field_short_title : title}
          </a>
        </h3>

        {programTermType()}

        <div className="program--lang-prereq mb-10">
          <label className="font-bold inline">
            {intl.formatMessage({id: 'ProgramCard.PrerequisitesLanguage'})}
          </label>
          {typeof field_prgm_lang_pre_lvl === 'object' ? field_prgm_lang_pre_lvl.join(', ') : field_prgm_lang_pre_lvl}
        </div>

        {field_prgm_options ?
          <div className="program--options mb-10">
            <label className="font-bold inline">{intl.formatMessage({id: 'ProgramCard.ProgramOptions'})}</label>
            {typeof field_prgm_options === 'object' ? field_prgm_options.join(', ') : field_prgm_options}
          </div> : ''
        }

        <div className="program-card__details-footer mt-auto">
          {field_prgm_cost_est ?
            <div className="program--costs flex justify-between">
              <label>{intl.formatMessage({id: 'ProgramCard.EstimatedCost'})}
                <div className="program-tooltip">
                  <Tooltip title={intl.formatMessage({id: 'ProgramCard.ProgramCostTooltip'})}
                           arrow={true}
                           tabIndex={0}
                           inertia={true}
                           interactive={true}>
                    <TooltipIcon/>
                  </Tooltip>
                </div>
              </label>

              <div className="program--price font-bold text-grey-dark flex">
                {field_prgm_cost_est === -1 ?
                  intl.formatMessage({id: 'ProgramCard.Price.Pending'})
                  : `${field_prgm_cost_units}${intl.formatNumber(field_prgm_cost_est)}`
                }
              </div>
            </div> : ''
          }
          <a href={url} className="button button--small justify-center w-full mt-24">
            {intl.formatMessage({id: 'ProgramCard.ProgramDetails.Button'})}
          </a>
        </div>
      </div>
    </article>
  );

  return (
    <>
      {desktop}
      {mobile}
    </>
  )
};

export default CardItem;
